// extracted by mini-css-extract-plugin
export default {"modalContentContainer":"CustomModal_modalContentContainer__9F6GU","closeButtonContainer":"CustomModal_closeButtonContainer__V0yjR","closeIcon":"CustomModal_closeIcon__wP6kF"};